exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._7c06c1{position:relative;transition:height 200ms cubic-bezier(1, 0, 0, 1)}._7c06c1.growing{transition:height 200ms cubic-bezier(0.24, 0.88, 0.27, 1.12)}._7c06c1._0846f9>:first-child{position:absolute;top:0;right:0;bottom:auto;left:0}._7c06c1:not(._0846f9){transition:none}._270f9d{overflow:hidden}", ""]);
// Exports
exports.locals = {
	"container": "_7c06c1",
	"mounted": "_0846f9",
	"overflow-hidden": "_270f9d",
	"overflowHidden": "_270f9d"
};